/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable no-shadow */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import axios from 'axios';
import Helmet from 'react-helmet';
import {
  Box,
  Spinner,
  Alert,
  AlertIcon,
  Heading,
  Text,
  Badge,
  Button,
  Center,
  useDisclosure,
  Icon,
  Flex,
  Container,
  SimpleGrid,
  VStack,
} from '@chakra-ui/react';
import { GiMagicTrident } from 'react-icons/gi';

// import PaymentForm from '../components/PaymentForm';
import { useAuth } from '../contexts/AuthContext';
import EventVariants from '../components/EventDetail/EventVariants';
import EventRewardSetsSection from '../components/EventDetail/EventRewardSetsSection';
import EventInfoBar from '../components/EventDetail/EventInfoBar';
import EventRegistrationMeters from '../components/EventDetail/EventRegistrationMeters';
import {
  EventPricingSection,
  EventProgrammaDettagli,
} from '../components/EventDetail/EventInfoSections';
import EventDetailDrawer from '../components/EventDetail/EventDetailDrawer';
import CentroEstivo from '../components/CentroEstivo2025';
import CentroEstivo2026 from '../components/CentroEstivo2026';
import MunlightSonata from '../components/MunlightSonata';
import WaitlistModal from '../components/CentroEstivo2026/WaitlistModal';
import {
  calculateVariantAvailableSeats,
  filterFutureObjects,
  getCountdown,
  getRecurringStartAndEndDate,
  getRegistrationOpenState,
  getVariantPrice,
  isEventEffectivelyFree,
  sortVariantiByDate,
} from '../utils';
import { fetchDecksByIds } from '../utils/deckApi';
import EventNotFound from '../components/EventNotFound';
import NotificationPopup from '../components/NotificationPopup';
import { getPendingNotificationsCount as getPendingNotificationsCountFromUser } from '../utils/pendingNotifications';
import { useEventBooking } from '../hooks/useEventBooking';
import { useGuestEventBooking } from '../hooks/useGuestEventBooking';
import GuestEventBookingDrawer from '../components/EventDetail/GuestEventBookingDrawer';
import TesseramentoRapidoDrawer from '../components/EventDetail/TesseramentoRapidoDrawer';
import {
  shouldUseGuestBookingFlow,
  hasPendingTesseramenti,
  computeGuestAvailableSeats,
  capienzaEvento,
  countEventOccupiedSeats,
  guestBookingSupportedForEvent,
  isVariantOpenToGuests,
} from '../utils/guestEventEligibility';
import { trackEvent } from '../utils/umami';

const italianDays = {
  Domenica: 0,
  Lunedì: 1,
  Martedì: 2,
  Mercoledì: 3,
  Giovedì: 4,
  Venerdì: 5,
  Sabato: 6,
};

const CENTRO_ESTIVO_2026_URLS = [
  'centro-estivo',
  'centro-estivo-2026',
  'centro-estivo-cil-2026',
];

const MUNLIGHT_SONATA_URLS = ['munlight-sonata'];
const PUBLIC_SITE_URL = (
  process.env.REACT_APP_PUBLIC_SITE_URL || 'https://www.cilassociazione.it'
).replace(/\/+$/, '');
const PUBLIC_MEDIA_URL = (
  process.env.REACT_APP_PUBLIC_MEDIA_URL ||
  process.env.REACT_APP_STRAPI_API_URL ||
  ''
).replace(/\/+$/, '');
const DEFAULT_OG_IMAGE = `${PUBLIC_SITE_URL}/og-default.svg`;

const toAbsoluteMediaUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (!PUBLIC_MEDIA_URL) return '';
  return `${PUBLIC_MEDIA_URL}${url.startsWith('/') ? url : `/${url}`}`;
};

function EventDetail({ userData, eventsData }) {
  const { requestUserData } = useAuth();
  const { urlTitle } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Stato evento e fetch
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(null);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isGuestOpen,
    onOpen: onGuestOpen,
    onClose: onGuestClose,
  } = useDisclosure();
  const {
    isOpen: isRapidOpen,
    onOpen: onRapidOpen,
    onClose: onRapidClose,
  } = useDisclosure();

  const remotePaymentStatus = searchParams.get('redirect_status');

  const [participantDecks, setParticipantDecks] = useState([]);
  const [loadingDecks, setLoadingDecks] = useState(false);

  const fetchEventRef = useRef(null);

  const booking = useEventBooking(event, userData, {
    isOpen,
    onOpen,
    onClose,
    onOrderSuccess: () => navigate('/account/ordini'),
    requestUserData,
    refetchEvent: () => fetchEventRef.current?.(),
  });

  // Variante cliccata prima di aprire il drawer ospite (null = la sceglie nel drawer)
  const [guestVariantId, setGuestVariantId] = useState(null);
  const openGuestBooking = useCallback(
    (variantId = null) => {
      setGuestVariantId(typeof variantId === 'string' ? variantId : null);
      trackEvent('registration_start', {
        event_id: event?.documentId,
        flow: 'ospite',
      });
      onGuestOpen();
    },
    [onGuestOpen, event?.documentId]
  );

  // Il tesseramento vero e proprio (membership_start) parte all'invio del modulo
  const openRapidSignup = useCallback(() => {
    trackEvent('registration_start', {
      event_id: event?.documentId,
      flow: 'tesseramento_rapido',
    });
    onRapidOpen();
  }, [onRapidOpen, event?.documentId]);

  const guestBooking = useGuestEventBooking(event, {
    isOpen: isGuestOpen,
    onClose: onGuestClose,
    initialVariantId: guestVariantId,
  });

  const { selectedParticipant } = booking;

  // Stato per il popup delle notifiche
  const [showNotificationPopup, setShowNotificationPopup] = useState(false);

  const hasOpenedDrawerFromQuery = useRef(false);

  // Countdown apertura iscrizioni (aggiornamento ogni secondo quando evento ha aperturaIscrizioniAt)
  const [now, setNow] = useState(() => Date.now());
  const aperturaIscrizioniAtMs =
    event?.aperturaIscrizioniAt != null
      ? new Date(event.aperturaIscrizioniAt).getTime()
      : null;
  const showAperturaCountdown =
    aperturaIscrizioniAtMs != null && now < aperturaIscrizioniAtMs;
  const countdownIntervalRef = useRef(null);
  useEffect(() => {
    if (!event?.aperturaIscrizioniAt || aperturaIscrizioniAtMs == null) {
      return () => {};
    }
    if (Date.now() >= aperturaIscrizioniAtMs) return () => {};
    countdownIntervalRef.current = setInterval(() => {
      const t = Date.now();
      setNow(t);
      if (t >= aperturaIscrizioniAtMs && countdownIntervalRef.current) {
        clearInterval(countdownIntervalRef.current);
        countdownIntervalRef.current = null;
      }
    }, 1000);
    return () => {
      if (countdownIntervalRef.current) {
        clearInterval(countdownIntervalRef.current);
        countdownIntervalRef.current = null;
      }
    };
  }, [event?.aperturaIscrizioniAt, aperturaIscrizioniAtMs]);

  // Sconti utente (per early-access iscrizioni)
  const [availableDiscounts, setAvailableDiscounts] = useState([]);
  useEffect(() => {
    if (!userData?.id) {
      setAvailableDiscounts([]);
      return;
    }
    const fetchDiscounts = async () => {
      try {
        const response = await fetch('/api/user/discounts');
        if (response.ok) {
          const data = await response.json();
          setAvailableDiscounts(data.discounts || []);
        }
      } catch (err) {
        console.error('Errore nel caricamento degli sconti:', err);
      }
    };
    fetchDiscounts();
  }, [userData?.id]);

  // Lista d'attesa (solo per Centro Estivo 2026)
  const [waitlistVariant, setWaitlistVariant] = useState(null);
  const [isWaitlistModalOpen, setIsWaitlistModalOpen] = useState(false);
  const handleListaAttesaClick = useCallback((variant) => {
    setWaitlistVariant(variant);
    setIsWaitlistModalOpen(true);
  }, []);
  const closeWaitlistModal = useCallback(() => {
    setIsWaitlistModalOpen(false);
    setWaitlistVariant(null);
  }, []);

  // Helper per calcolare le notifiche pendenti
  const getPendingNotificationsCount = () =>
    getPendingNotificationsCountFromUser(userData);

  // Mostra il popup delle notifiche quando l'utente ha notifiche pendenti (massimo una volta al giorno)
  useEffect(() => {
    if (userData && getPendingNotificationsCount() > 0) {
      const LAST_POPUP_DATE_KEY = 'lastNotificationPopupDate';
      const now = new Date();
      const today = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      ).getTime();

      // Recupera la data dell'ultima visualizzazione dal localStorage
      const lastPopupDate = localStorage.getItem(LAST_POPUP_DATE_KEY);

      // Se non c'è una data salvata o è passato almeno un giorno, mostra il popup
      const shouldShowPopup =
        !lastPopupDate || today > parseInt(lastPopupDate, 10);

      if (shouldShowPopup) {
        // Mostra il popup dopo un breve delay per permettere al componente di caricare
        const timer = setTimeout(() => {
          setShowNotificationPopup(true);
        }, 1000);

        return () => clearTimeout(timer);
      }
    }
    return undefined;
  }, [userData]);

  // Calcola se i mazzi possono essere mostrati (all'ora di inizio dell'evento)
  const canShowDecks = () => {
    if (!event?.Data || !event?.Ora_inizio) return false;

    const eventDate = new Date(event.Data);
    const [hours, minutes] = event.Ora_inizio.split(':').map(Number);
    eventDate.setHours(hours, minutes, 0, 0);

    const now = new Date();

    return now >= eventDate;
  };

  const existingEvent = eventsData.find((e) => e.urlTitle === urlTitle);

  const filteredVarianti = sortVariantiByDate(
    filterFutureObjects(
      event?.Varianti?.filter((variant) => {
        const availableSeats = calculateVariantAvailableSeats(variant);

        if (selectedParticipant) {
          const socioOrders = userData?.orders?.filter(
            (order) =>
              order.socio?.documentId === selectedParticipant &&
              order?.event?.documentId === event?.documentId
          );

          const uniqueProducts = Array.from(
            new Set(
              socioOrders.reduce((acc, order) => {
                const products =
                  order?.metadata?.products?.map((product) => product.id) || [];

                return [...acc, ...products];
              }, [])
            )
          );

          if (
            availableSeats < 1 ||
            (uniqueProducts && uniqueProducts.includes(variant.documentId))
          ) {
            return false;
          }
        }

        return Boolean(availableSeats > 0);
      })
    )
  );

  // Tutte le varianti future (disponibili + già acquistate) per mostrare nella lista
  const allVarianti = sortVariantiByDate(
    filterFutureObjects(event?.Varianti || [])
  );

  // Helper per verificare se l'utente ha già acquistato una specifica variante
  const hasAlreadyPurchasedVariant = (variantId) => {
    if (!selectedParticipant) return false;

    const socioOrders = userData?.orders?.filter(
      (order) =>
        order.socio?.documentId === selectedParticipant &&
        order?.event?.documentId === event?.documentId
    );

    const uniqueProducts = Array.from(
      new Set(
        socioOrders.reduce((acc, order) => {
          const products =
            order?.metadata?.products?.map((product) => product.id) || [];
          return [...acc, ...products];
        }, [])
      )
    );

    return uniqueProducts.includes(variantId);
  };

  let userOrders = userData?.orders || [];

  if (event?.Recurring) {
    const targetDay = italianDays[event.Recurring];

    if (targetDay !== undefined) {
      const { startDate, endDate } = getRecurringStartAndEndDate(targetDay);

      // 2. Filter userData?.orders by the same date range
      userOrders = (userData?.orders || []).filter((order) => {
        const orderDate = new Date(order.createdAt);
        return orderDate >= startDate && orderDate <= endDate;
      });
    }
  }

  // Fetch participant decks when event orders are available
  useEffect(() => {
    const loadParticipantDecks = async () => {
      if (event?.checkoutMode === 'deck' && event?.orders) {
        setLoadingDecks(true);
        try {
          // Estrai tutti i deck-documentId unici dagli ordini dell'evento
          const deckIds = new Set();

          event.orders.forEach((order) => {
            // Controlla se c'è un deck-documentId direttamente nel metadata
            if (order.metadata?.['deck-documentId']) {
              deckIds.add(order.metadata['deck-documentId']);
            }

            // Controlla anche nei prodotti per compatibilità
            if (order.metadata?.products) {
              order.metadata.products.forEach((product) => {
                if (product['deck-documentId']) {
                  deckIds.add(product['deck-documentId']);
                }
              });
            }
          });

          // Recupera tutti i deck in una sola chiamata
          const deckIdsArray = Array.from(deckIds);
          if (deckIdsArray.length > 0) {
            const decks = await fetchDecksByIds(deckIdsArray);
            setParticipantDecks(decks);
          } else {
            setParticipantDecks([]);
          }
        } catch (error) {
          console.error(
            'Errore nel caricamento dei mazzi partecipanti:',
            error
          );
          setParticipantDecks([]);
        } finally {
          setLoadingDecks(false);
        }
      }
    };

    loadParticipantDecks();
  }, [event?.checkoutMode, event?.documentId]);

  const paidParticipants =
    userOrders.reduce((acc, order) => {
      if (order.event) {
        if (order.event.documentId === event?.documentId) {
          const orderProducts = order.metadata.products.filter((p) =>
            ['totale', 'acconto'].includes(p.paymentType)
          );

          if (!acc[order.socio.documentId]) {
            return {
              ...acc,
              [order.socio.documentId]: [...orderProducts],
            };
          }

          return {
            ...acc,
            [order.socio.documentId]: [
              ...acc[order.socio.documentId],
              ...orderProducts,
            ],
          };
        }
      }

      return acc;
    }, {}) || {};

  const paidParticipantCount = Object.keys(paidParticipants).length;
  const tesseramentiCount = userData?.tesseramenti?.length ?? 0;

  const allParticipantsPaidInFull =
    tesseramentiCount > 0 &&
    paidParticipantCount > 0 &&
    paidParticipantCount === tesseramentiCount;

  const allVariantParticipantsPaidInFull =
    !selectedParticipant &&
    allParticipantsPaidInFull &&
    filteredVarianti.length > 0 &&
    Object.keys(paidParticipants).every((p) =>
      filteredVarianti.every((variant) =>
        paidParticipants[p].some((product) => product.id === variant.documentId)
      )
    );

  // Helper per verificare se l'utente ha almeno un tesseramento valido per l'anno corrente
  const hasValidTesseramentoForCurrentYear = () => {
    if (!userData?.tesseramenti || userData.tesseramenti.length === 0) {
      return false;
    }

    const currentYear = new Date().getFullYear();

    return userData.tesseramenti.some((socio) => {
      const tesseramentiSocio =
        socio.tesseramenti && Array.isArray(socio.tesseramenti)
          ? socio.tesseramenti
          : [];

      return tesseramentiSocio.some(
        (t) =>
          t.anno === currentYear &&
          (t.paymentStatus === 'succeeded' || t.paymentStatus === 'pending')
      );
    });
  };

  const ordersFromOtherParticipants = {};

  userOrders.forEach((o) =>
    o?.metadata?.products?.forEach((p) => {
      if (
        filteredVarianti.map((v) => v.documentId).includes(p.id) &&
        o.socio.documentId !== selectedParticipant
      ) {
        ordersFromOtherParticipants[p.id] = p.id;
      }
    })
  );

  const isCentroEstivo = event?.urlTitle === 'centro-estivo-2025';
  const isCentroEstivo2026 = CENTRO_ESTIVO_2026_URLS.includes(event?.urlTitle);
  const isMunlightSonata = MUNLIGHT_SONATA_URLS.includes(event?.urlTitle);
  const isCentroEstivoPage = isCentroEstivo || isCentroEstivo2026;
  const shareImage =
    toAbsoluteMediaUrl(event?.thumbnail?.url) || DEFAULT_OG_IMAGE;
  const shareUrl = event?.urlTitle
    ? `${PUBLIC_SITE_URL}/event/${encodeURIComponent(event.urlTitle)}`
    : `${PUBLIC_SITE_URL}/event`;

  const fetchEvent = async () => {
    try {
      const response = await axios.get(
        `/api/eventi?urlTitle=${encodeURIComponent(urlTitle)}`
      );
      if (response.data) {
        setEvent(response.data);
      } else {
        setFetchError('Evento non trovato');
      }
    } catch (error) {
      console.error("Errore nel recupero dell'evento:", error.message);
      if (error.response?.status === 404) {
        setFetchError('not-found');
        return;
      }

      setFetchError(error.message);
    } finally {
      setLoading(false);
    }
  };

  fetchEventRef.current = fetchEvent;

  // Una sola visualizzazione per evento, anche con il refresh ogni 15 s
  const trackedEventViewRef = useRef(null);
  useEffect(() => {
    if (!event?.documentId || trackedEventViewRef.current === event.documentId)
      return;
    trackedEventViewRef.current = event.documentId;
    trackEvent('event_view', { event_id: event.documentId });
  }, [event?.documentId]);

  useEffect(() => {
    if (!existingEvent) {
      setLoading(true);
    }

    fetchEvent();

    const interval = setInterval(() => {
      fetchEvent();
    }, 15000);

    return () => {
      clearInterval(interval);
    };
  }, [urlTitle]);

  useEffect(() => {
    if (existingEvent) {
      // Non sovrascrivere se l'evento corrente ha già i progetti popolati
      if (!event?.projects && existingEvent) {
        setEvent(existingEvent);
      }
    }
  }, [existingEvent, event?.projects]);

  useEffect(() => {
    if (remotePaymentStatus && event?.urlTitle) {
      onOpen();

      navigate(`/event/${event.urlTitle}`, { replace: true });
    }
  }, [remotePaymentStatus, event?.urlTitle]);

  useEffect(() => {
    if (remotePaymentStatus === 'succeeded') {
      const timer = setTimeout(() => {
        requestUserData({ withLoading: false });
        fetchEvent();
      }, 2000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [remotePaymentStatus]);

  useEffect(() => {
    if (
      (CENTRO_ESTIVO_2026_URLS.includes(urlTitle) ||
        MUNLIGHT_SONATA_URLS.includes(urlTitle)) &&
      searchParams.get('openDrawer') === '1' &&
      event &&
      userData &&
      !hasOpenedDrawerFromQuery.current
    ) {
      hasOpenedDrawerFromQuery.current = true;
      trackEvent('registration_start', {
        event_id: event.documentId,
        flow: 'socio',
      });
      booking.handleOpenDrawer();
      navigate(`/event/${urlTitle}`, { replace: true });
    }
  }, [urlTitle, event?.documentId, userData?.id, booking.handleOpenDrawer]);

  // Evita errori verificando se event è definito
  const isRecurring = event?.Recurring || null;

  // Formatta data (nome mese per esteso in italiano)
  const eventDate = event?.Data ? new Date(event.Data) : null;
  const eventEndDate = event?.Date_end ? new Date(event.Date_end) : null;

  const fullDate = eventDate
    ? eventDate.toLocaleDateString('it-IT', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    : 'Data non disponibile';

  const endDate = eventEndDate
    ? eventEndDate.toLocaleDateString('it-IT', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    : null;

  // Se è ricorrente, mostra "Ogni [Periodo]", altrimenti mostra la data
  const eventTag = isRecurring
    ? `Ogni ${isRecurring}`
    : endDate
      ? `${fullDate} - ${endDate}`
      : fullDate;

  // Capienza dell'evento, oppure dell'unico modulo se l'evento non ne ha
  const eventCapacity = capienzaEvento(event);

  const occupied = countEventOccupiedSeats(event);
  const availableSeats = eventCapacity ? eventCapacity - occupied : null;
  const progressValue = eventCapacity
    ? (availableSeats / eventCapacity) * 100
    : 0;

  // Logica minimo partecipanti
  const hasMinimumParticipants = event?.minimoPartecipanti != null;
  const currentParticipants = occupied;
  const minimumRequired = event?.minimoPartecipanti || 0;

  // const variantsSoldOut = event?.Varianti.every((variant) => {
  //   // Conta i soci unici invece di tutti gli ordini
  //   const activeVariantOrders = variant?.Ordini?.filter((order) => {
  //     // Filtra gli ordini cancellati
  //     const isCancelled = order.metadata?.products?.some(product => product.isCancelled === true);
  //     if (isCancelled) return false;

  //     return order.metadata.products.some(
  //       (product) =>
  //         product.type === 'variant' &&
  //         ['acconto', 'totale'].includes(product.paymentType) &&
  //         product.id === variant.documentId
  //     );
  //   }) || [];

  //   const uniqueVariantSocios = new Set();
  //   activeVariantOrders.forEach(order => {
  //     const socioId = order.socio?.documentId || order.socio?.email;
  //     if (socioId) {
  //       uniqueVariantSocios.add(socioId);
  //     }
  //   });

  //   const availableVariantSeats = variant?.capienza
  //     ? variant.capienza - uniqueVariantSocios.size
  //     : 0;

  //   return availableVariantSeats < 1;
  // });

  // Per eventi con varianti, controlla se almeno una variante ha posti disponibili
  const hasAvailableVariants =
    Boolean(event?.Varianti?.length) &&
    event.Varianti.some((variant) => {
      const availableSeats = calculateVariantAvailableSeats(variant);
      return availableSeats > 0;
    });
  const isSoldOut =
    (eventCapacity != null &&
      availableSeats <= 0 &&
      !event?.Varianti?.length) ||
    (event?.Varianti?.length && !hasAvailableVariants);

  const { registrationOpen, isEarlyAccessOnly } = event
    ? getRegistrationOpenState(event, userData, availableDiscounts)
    : { registrationOpen: false, isEarlyAccessOnly: false };

  const guestFlowActive = shouldUseGuestBookingFlow(event, userData, {
    registrationOpen,
    isEarlyAccessOnly,
  });
  const guestBookingAvailable =
    guestBookingSupportedForEvent(event) &&
    registrationOpen &&
    !isEarlyAccessOnly;
  const guestAvailableSeats = computeGuestAvailableSeats(event);
  const guestSoldOut = guestFlowActive && guestAvailableSeats <= 0;
  const pendingTesseramenti = hasPendingTesseramenti(userData);
  // Checkout con tesseramento rapido per chi non è ancora socio
  const rapidCheckoutAvailable =
    event?.checkoutMode === 'tesseramento_rapido' &&
    registrationOpen &&
    !isEarlyAccessOnly &&
    !isSoldOut;

  // Il nuovo account è già autenticato: ricarica i dati utente e l'evento
  // (il socio può essere stato iscritto insieme alla tessera)
  const closeRapidDrawer = () => {
    requestUserData({ withLoading: false });
    fetchEventRef.current?.();
    onRapidClose();
  };

  const handleRapidContinue = async () => {
    await requestUserData({ withLoading: false });
    onRapidClose();
    booking.handleOpenDrawer();
  };

  const handleParticipateClick = useCallback(
    (variant) => {
      // Dai bottoni arriva l'evento del click, dalle schede la variante
      const clicked = variant?.documentId ? variant : null;
      if (
        guestFlowActive &&
        (!clicked || isVariantOpenToGuests(clicked, event))
      ) {
        openGuestBooking(clicked?.documentId || null);
        return;
      }
      trackEvent('registration_start', {
        event_id: event?.documentId,
        flow: 'socio',
      });
      booking.handleOpenDrawer(variant);
    },
    [guestFlowActive, openGuestBooking, booking, event]
  );

  const renderGuestBookingButton = (showLoginLink = false) => (
    <Flex flexDirection="column" alignItems="center" gap={1}>
      <Button
        colorScheme="blue"
        size="lg"
        onClick={() => openGuestBooking()}
        isDisabled={!registrationOpen}
        mt={2}
        minW="200px"
        data-testid="event-register-button"
      >
        {registrationOpen
          ? 'Partecipa come ospite'
          : 'Le iscrizioni apriranno a breve'}
      </Button>
      {showLoginLink && registrationOpen ? (
        <Text fontSize="sm" color="gray.600">
          oppure{' '}
          <Button
            as={Link}
            to={`/login?redirect=${encodeURIComponent(location.pathname)}`}
            variant="link"
            colorScheme="blue"
            size="sm"
          >
            effettua il login
          </Button>
        </Text>
      ) : null}
    </Flex>
  );

  const renderGuestDrawer = () =>
    isGuestOpen && guestBookingAvailable ? (
      <GuestEventBookingDrawer
        isOpen={isGuestOpen}
        placement={booking.placement}
        onClose={onGuestClose}
        event={event}
        booking={guestBooking}
      />
    ) : null;

  const renderRapidDrawer = () =>
    isRapidOpen ? (
      <TesseramentoRapidoDrawer
        isOpen={isRapidOpen}
        placement={booking.placement}
        onClose={closeRapidDrawer}
        event={event}
        onContinue={handleRapidContinue}
      />
    ) : null;

  const renderSocioDrawer = () =>
    isOpen &&
    userData &&
    !guestFlowActive &&
    hasValidTesseramentoForCurrentYear() ? (
      <EventDetailDrawer
        isOpen={isOpen}
        placement={booking.placement}
        onModalClose={booking.onModalClose}
        event={event}
        userData={userData}
        userDecks={booking.userDecks}
        clientSecret={booking.clientSecret}
        paymentError={booking.paymentError}
        paymentLoading={booking.paymentLoading}
        paymentSuccess={booking.paymentSuccess}
        paymentMethod={booking.paymentMethod}
        onPaymentSuccess={booking.onPaymentSuccess}
        selectedParticipant={booking.selectedParticipant}
        handleConfirm={booking.handleConfirm}
        getDisabledPartecipant={booking.getDisabledPartecipant}
        showPaymentForm={booking.showPaymentForm}
        setSelectedParticipant={booking.setSelectedParticipant}
        priceOption={booking.priceOption}
        setPaymentMethod={booking.setPaymentMethod}
        handlePriceOptionChange={booking.handlePriceOptionChange}
        selectedVariantPriceOptions={booking.selectedVariantPriceOptions}
        filteredVarianti={booking.filteredVarianti}
        ordersFromOtherParticipants={booking.ordersFromOtherParticipants}
        onDeckSelectionChange={booking.handleDeckSelectionChange}
        allVarianti={booking.allVarianti}
        hasAlreadyPurchasedVariant={booking.hasAlreadyPurchasedVariant}
        onProceedToPayment={booking.handleProceedToPayment}
        variantSelectionsConfirmed={booking.variantSelectionsConfirmed}
        onConfirmVariantSelections={booking.confirmVariantSelections}
        onReopenVariantSelection={booking.reopenVariantSelection}
        preselectedVariantId={booking.preselectedVariantId}
      />
    ) : null;

  const getSeatsPhrase = (value) => {
    if (value < 25) return 'Attenzione, pochi posti rimasti!';
    if (value < 50) return 'Ancora qualche posto disponibile!';
    return 'Disponibilità ampia, unisciti a noi!';
  };

  const getProgressColor = (value) => {
    if (value < 25) return 'red';
    if (value < 50) return 'yellow';
    return 'green';
  };

  const descrizioneBlock = (
    <>
      {/* Descrizione breve */}
      <Heading as="h2" size="md" mb={3} color="gray.800">
        Descrizione
      </Heading>
      <Text fontSize="md" color="gray.800" mb={6} whiteSpace="pre-wrap">
        {event?.Descrizione || 'Nessuna descrizione disponibile.'}
      </Text>
    </>
  );

  const teamBlock = (
    <>
      {/* Sezione Team Progetto */}
      {/* Gestisce array di progetti (many-to-many) */}
      {event?.projects &&
        Array.isArray(event?.projects) &&
        event?.projects.length > 0 && (
          // eslint-disable-next-line react/jsx-no-useless-fragment
          <>
            {event?.projects.map(
              (project, projectIndex) =>
                project.team &&
                project.team.length > 0 && (
                  <Box
                    key={project.documentId || project.id || projectIndex}
                    mb={4}
                  >
                    {(() => {
                      const referenti = project.team.filter(
                        (member) => member.ruolo === 'referente'
                      );
                      return (
                        referenti.length > 0 && (
                          <Text fontSize="md" color="gray.800" mb={2}>
                            <Text as="span" fontWeight="semibold">
                              {referenti.length === 1
                                ? 'Referente: '
                                : 'Referenti: '}
                            </Text>
                            {referenti
                              .map(
                                (member) =>
                                  `${member.nomeSocio} ${member.cognomeSocio}`
                              )
                              .join(', ')}
                          </Text>
                        )
                      );
                    })()}
                    {project.team.filter(
                      (member) => member.ruolo === 'collaboratore'
                    ).length > 0 && (
                      <Text fontSize="md" color="gray.800" mb={6}>
                        <Text as="span" fontWeight="semibold">
                          Collaboratori:{' '}
                        </Text>
                        {project.team
                          .filter((member) => member.ruolo === 'collaboratore')
                          .map(
                            (member) =>
                              `${member.nomeSocio} ${member.cognomeSocio}`
                          )
                          .join(', ')}
                      </Text>
                    )}
                  </Box>
                )
            )}
          </>
        )}
    </>
  );

  // Varianti + CTA: dentro "Dettagli evento" (il vecchio Centro Estivo 2025 le tiene nel riquadro Iscrizioni)
  const variantiSection =
    event?.Varianti?.length > 0 ? (
      <>
        {hasMinimumParticipants && (
          <Box mb={4}>
            <EventRegistrationMeters
              minimumRequired={minimumRequired}
              currentParticipants={currentParticipants}
            />
          </Box>
        )}
        <EventVariants
          embedded
          event={event}
          handleOpenDrawer={handleParticipateClick}
          onGuestBooking={guestFlowActive ? openGuestBooking : undefined}
          onQuickSignup={rapidCheckoutAvailable ? openRapidSignup : undefined}
          userData={userData}
          isSoldOut={isSoldOut}
          allParticipantsPaidInFull={allVariantParticipantsPaidInFull}
          allVarianti={allVarianti}
          hasAlreadyPurchasedVariant={hasAlreadyPurchasedVariant}
          registrationOpen={registrationOpen}
          isEarlyAccessOnly={isEarlyAccessOnly}
        />
      </>
    ) : null;
  const variantiInDettagli = Boolean(variantiSection) && !isCentroEstivo;

  // Prezzo per la barra info (stessa logica del vecchio badge nell'hero)
  const infoBarPrice = (() => {
    if (event?.Varianti?.length) {
      const options =
        event.Varianti.length === 1
          ? '1 opzione'
          : `${event.Varianti.length} opzioni`;
      if (isEventEffectivelyFree(event)) {
        return { title: 'Gratis', subtitle: options };
      }
      const prices = event.Varianti.map((v) => getVariantPrice(v, event));
      const min = Math.min(...prices);
      const max = Math.max(...prices);
      return {
        title:
          min === max ? `€ ${min}` : min === 0 ? 'Da gratis' : `Da € ${min}`,
        subtitle: options,
      };
    }
    if (event?.is_free) return { title: 'Gratis' };
    if (event?.prezzo == null) return {};
    return {
      title: `€ ${event.prezzo}`,
      subtitle: event.prezzoOriginale
        ? `invece di € ${event.prezzoOriginale}`
        : null,
    };
  })();

  // Finché non c'è né l'evento né una risposta di errore siamo ancora in
  // caricamento: senza questa guardia il primo render montava EventNotFound
  // (che traccia page_not_found) prima ancora della chiamata all'API.
  if (loading || (!event && !fetchError)) {
    return (
      <Center mt={10} width="100%" minH="50vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (fetchError && fetchError !== 'not-found') {
    return (
      <Alert status="error" mt={10}>
        <AlertIcon />
        Errore nel recupero dell&apos;evento: {fetchError}
      </Alert>
    );
  }
  if (!event || fetchError === 'not-found') {
    return <EventNotFound />;
  }

  // Eventi Centro Estivo 2026: mostriamo solo la pagina dedicata + drawer prenotazione
  if (isCentroEstivo2026) {
    return (
      <>
        <Helmet>
          <title>{event?.Nome}</title>
          <meta property="og:title" content={event?.Nome} />
          <meta property="og:description" content={event?.Descrizione} />
          <meta property="og:image" content={shareImage} />
          <meta property="og:url" content={shareUrl} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={event?.Nome} />
          <meta name="twitter:description" content={event?.Descrizione} />
          <meta name="twitter:image" content={shareImage} />
        </Helmet>
        <CentroEstivo2026
          event={event}
          onOpenDrawer={handleParticipateClick}
          onListaAttesaClick={handleListaAttesaClick}
          userData={userData}
        />
        <WaitlistModal
          isOpen={isWaitlistModalOpen}
          onClose={closeWaitlistModal}
          event={event}
          variant={waitlistVariant}
          userData={userData}
          fetchEvent={fetchEvent}
        />
        {renderSocioDrawer()}
        {renderGuestDrawer()}
        {renderRapidDrawer()}
        <NotificationPopup
          isOpen={showNotificationPopup}
          onClose={() => setShowNotificationPopup(false)}
          userData={userData}
        />
      </>
    );
  }

  // Munlight Sonata: landing dedicata + drawer prenotazione
  if (isMunlightSonata) {
    return (
      <>
        <Helmet>
          <title>{event?.Nome}</title>
          <meta property="og:title" content={event?.Nome} />
          <meta property="og:description" content={event?.Descrizione} />
          <meta property="og:image" content={shareImage} />
          <meta property="og:url" content={shareUrl} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={event?.Nome} />
          <meta name="twitter:description" content={event?.Descrizione} />
          <meta name="twitter:image" content={shareImage} />
        </Helmet>
        <MunlightSonata
          event={event}
          userData={userData}
          onOpenDrawer={handleParticipateClick}
          isSoldOut={isSoldOut}
          allParticipantsPaidInFull={allVariantParticipantsPaidInFull}
          allVarianti={allVarianti}
          registrationOpen={registrationOpen}
          isEarlyAccessOnly={isEarlyAccessOnly}
        />
        {renderSocioDrawer()}
        {renderGuestDrawer()}
        {renderRapidDrawer()}
        <NotificationPopup
          isOpen={showNotificationPopup}
          onClose={() => setShowNotificationPopup(false)}
          userData={userData}
        />
      </>
    );
  }

  // EventDetail standard (hero + dettagli + drawer)
  return (
    <Box bg="#36393f" minH="100vh" overflowX="hidden" color="white">
      <Helmet>
        <title>{event?.Nome}</title>
        <meta property="og:title" content={event?.Nome} />
        <meta property="og:description" content={event?.Descrizione} />
        <meta property="og:image" content={shareImage} />
        <meta property="og:url" content={shareUrl} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={event?.Nome} />
        <meta name="twitter:description" content={event?.Descrizione} />
        <meta name="twitter:image" content={shareImage} />
      </Helmet>

      {/* HERO SECTION - Discord Style */}
      <Box
        position="relative"
        w="100%"
        minH={{ base: '320px', md: '440px' }}
        overflow="hidden"
        backgroundImage={`url('${event?.thumbnail?.url || '/default-image-url.png'}')`}
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
      >
        {/* Overlay scuro per leggibilità */}
        <Box
          position="absolute"
          top="0"
          left="0"
          w="100%"
          h="100%"
          bg="rgba(0, 0, 0, 0.4)"
        />

        {/* Contenuto centrato */}
        <Container
          maxW="container.lg"
          minH={{ base: '320px', md: '440px' }}
          pt={{ base: 10, md: 12 }}
          pb={{ base: 14, md: 16 }}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          zIndex="2"
          position="relative"
          color="white"
          textAlign="center"
        >
          <VStack spacing={4} maxW="800px">
            {event?.category ? (
              <Badge
                fontSize={{ base: 'xs', md: 'sm' }}
                letterSpacing="wider"
                textTransform="uppercase"
                borderRadius="full"
                px={4}
                py={1}
                bg="whiteAlpha.300"
                color="white"
              >
                {event.category}
              </Badge>
            ) : null}

            <Box textAlign="center">
              <Heading
                as="h1"
                fontSize={{ base: '3xl', md: '5xl' }}
                color="white"
                textShadow="2px 2px 4px rgba(0,0,0,0.8)"
                fontWeight="extrabold"
                letterSpacing="wide"
                mb={2}
              >
                {event?.Nome || 'Titolo non disponibile'}
              </Heading>
              {/* Riga colorata sotto il titolo */}
              <Box
                w="120px"
                h="4px"
                bg={event?.color || '#ffcc00'}
                mx="auto"
                borderRadius="full"
                boxShadow="0 2px 8px rgba(0,0,0,0.3)"
              />
            </Box>

            {isSoldOut ? (
              <Badge
                colorScheme="red"
                fontSize={{ base: 'md', md: 'lg' }}
                px={6}
                py={3}
                borderRadius="lg"
                boxShadow="lg"
                fontWeight="bold"
              >
                Posti Esauriti!
              </Badge>
            ) : null}

            {showAperturaCountdown && aperturaIscrizioniAtMs != null ? (
              <Text
                fontSize={{ base: 'md', md: 'lg' }}
                color="white"
                textShadow="1px 1px 2px rgba(0,0,0,0.8)"
              >
                Le iscrizioni aprono tra:{' '}
                <Box as="span" color="#ffcc00" fontWeight="bold">
                  {(() => {
                    const { days, hours, minutes, seconds } = getCountdown(
                      now,
                      aperturaIscrizioniAtMs
                    );
                    return `${days} g ${String(hours).padStart(2, '0')} h ${String(minutes).padStart(2, '0')} m ${String(seconds).padStart(2, '0')} s`;
                  })()}
                </Box>
              </Text>
            ) : null}
          </VStack>
        </Container>
      </Box>

      <EventInfoBar
        event={event}
        whenTitle={eventTag}
        priceTitle={infoBarPrice.title}
        priceSubtitle={infoBarPrice.subtitle}
      />

      {/* Iscrizioni: posti, minimo partecipanti e bottoni (aprono il drawer) */}
      {!variantiInDettagli && (
        <Container maxW="container.xl" px={{ base: 2, md: 4 }}>
          <Box
            bg="white"
            color="gray.800"
            borderRadius="lg"
            boxShadow="md"
            p={{ base: 4, md: 6 }}
            mb={6}
          >
            <Heading as="h2" size="md" mb={4} color="gray.800">
              Iscrizioni
            </Heading>
            {variantiSection || (
              <SimpleGrid
                columns={{ base: 1, md: 2 }}
                templateColumns={{ md: '1fr auto' }}
                spacing={{ base: 5, md: 8 }}
                alignItems="center"
              >
                <EventRegistrationMeters
                  seats={
                    !event?.externalURL && !isSoldOut && eventCapacity
                      ? {
                          available: availableSeats,
                          capacity: eventCapacity,
                          color: getProgressColor(progressValue),
                          phrase: getSeatsPhrase(progressValue),
                        }
                      : null
                  }
                  minimumRequired={
                    hasMinimumParticipants ? minimumRequired : null
                  }
                  currentParticipants={currentParticipants}
                />
                <Box minW={{ md: '240px' }}>
                  {/* CTA partecipazione / login */}
                  {userData ? (
                    allParticipantsPaidInFull ? (
                      <Center flexDirection="column">
                        <Alert
                          status="success"
                          borderRadius="md"
                          width="auto"
                          boxShadow="lg"
                        >
                          <AlertIcon />
                          Sei già iscritto a questo evento!
                        </Alert>
                        {event?.urlTitle?.includes('magic') && userData ? (
                          <Button
                            as={Link}
                            rightIcon={<GiMagicTrident />}
                            to="/magicthegathering"
                            colorScheme="purple"
                            size="lg"
                            minW="200px"
                            mt={6}
                          >
                            Entra in MTG Tools
                          </Button>
                        ) : null}
                      </Center>
                    ) : (
                      <Center>
                        {!hasValidTesseramentoForCurrentYear() ? (
                          guestFlowActive ? (
                            <Flex
                              flexDirection="column"
                              gap={3}
                              alignItems="center"
                            >
                              {pendingTesseramenti ? (
                                <Alert
                                  status="warning"
                                  borderRadius="md"
                                  maxW="400px"
                                >
                                  <AlertIcon />
                                  <Box>
                                    <Text fontSize="sm">
                                      Hai uno o più tesseramenti da completare.{' '}
                                      <Button
                                        as={Link}
                                        to="/account/tesseramenti"
                                        variant="link"
                                        colorScheme="blue"
                                        size="sm"
                                      >
                                        Vai ai tesseramenti
                                      </Button>
                                    </Text>
                                  </Box>
                                </Alert>
                              ) : null}
                              {guestSoldOut ? (
                                <Button
                                  colorScheme="red"
                                  size="lg"
                                  disabled
                                  mt={2}
                                  minW="200px"
                                >
                                  Posti Esauriti
                                </Button>
                              ) : (
                                renderGuestBookingButton()
                              )}
                            </Flex>
                          ) : (
                            <Button
                              as={Link}
                              to="/account/tesseramenti"
                              colorScheme="blue"
                              size="lg"
                              minW="200px"
                              mt={2}
                            >
                              Rinnova Tessera
                            </Button>
                          )
                        ) : isCentroEstivoPage && !registrationOpen ? (
                          <Badge
                            bg="orange.300"
                            color="white"
                            fontSize="lg"
                            minW="200px"
                            borderRadius={6}
                            px={4}
                            py={2}
                            mt={2}
                          >
                            Le iscrizioni apriranno a breve!
                          </Badge>
                        ) : event.externalURL ? (
                          <Button
                            colorScheme="purple"
                            size="lg"
                            minW="200px"
                            as={Link}
                            to={event.externalURL}
                            mt={2}
                            data-umami-event="external_booking_click"
                            data-umami-event-event_id={event.documentId}
                          >
                            Partecipa
                          </Button>
                        ) : (
                          <Flex flexDirection="column">
                            {isSoldOut ? (
                              <Button
                                colorScheme="red"
                                size="lg"
                                disabled
                                mt={2}
                                minW="200px"
                              >
                                Posti Esauriti
                              </Button>
                            ) : (
                              <Flex
                                flexDirection="column"
                                gap={2}
                                alignItems="center"
                              >
                                <Button
                                  colorScheme="blue"
                                  size="lg"
                                  onClick={handleParticipateClick}
                                  isDisabled={!registrationOpen}
                                  mt={2}
                                  minW="200px"
                                  data-testid="event-register-button"
                                >
                                  {registrationOpen
                                    ? isEarlyAccessOnly
                                      ? 'Partecipa (Early access)'
                                      : 'Partecipa'
                                    : 'Le iscrizioni apriranno a breve'}
                                </Button>
                                {isEarlyAccessOnly && !registrationOpen && (
                                  <Button
                                    as={Link}
                                    to="/sostienicil"
                                    colorScheme="purple"
                                    size="lg"
                                    minW="200px"
                                    variant="outline"
                                  >
                                    Sostieni CIL per l&apos;early access
                                  </Button>
                                )}
                              </Flex>
                            )}
                          </Flex>
                        )}
                      </Center>
                    )
                  ) : (
                    <Center>
                      {event.externalURL ? (
                        <Button
                          colorScheme="yellow"
                          size="lg"
                          as={Link}
                          minW="200px"
                          to={event.externalURL}
                          mt={2}
                          target="_blank"
                          isDisabled={!registrationOpen}
                          data-umami-event="external_booking_click"
                          data-umami-event-event_id={event.documentId}
                        >
                          Partecipa
                        </Button>
                      ) : rapidCheckoutAvailable ? (
                        // Vale anche per eventi gratuiti e aperti a tutti:
                        // la modalità scelta in admin ha la precedenza
                        <Flex
                          flexDirection="column"
                          alignItems="center"
                          gap={1}
                        >
                          <Button
                            colorScheme="blue"
                            size="lg"
                            minW="200px"
                            mt={2}
                            onClick={openRapidSignup}
                            data-testid="event-quick-signup-button"
                          >
                            Tesserati e iscriviti
                          </Button>
                          {guestBookingAvailable && !guestSoldOut ? (
                            <Text fontSize="sm" color="gray.600">
                              oppure{' '}
                              <Button
                                variant="link"
                                colorScheme="blue"
                                size="sm"
                                onClick={() => openGuestBooking()}
                              >
                                partecipa come ospite
                              </Button>
                            </Text>
                          ) : null}
                        </Flex>
                      ) : guestBookingAvailable ? (
                        guestSoldOut ? (
                          <Button
                            colorScheme="red"
                            size="lg"
                            disabled
                            minW="200px"
                            mt={2}
                          >
                            Posti Esauriti
                          </Button>
                        ) : (
                          renderGuestBookingButton(true)
                        )
                      ) : (
                        <Button
                          as={Link}
                          to={
                            isEarlyAccessOnly && !registrationOpen
                              ? '/sostienicil'
                              : '/tesseramento'
                          }
                          colorScheme="blue"
                          size="lg"
                          minW="200px"
                          isDisabled={
                            isSoldOut ||
                            (isCentroEstivoPage && !registrationOpen)
                          }
                          mt={2}
                        >
                          {isEarlyAccessOnly && !registrationOpen
                            ? "Sostieni CIL per l'early access"
                            : isCentroEstivoPage && !registrationOpen
                              ? 'Le iscrizioni apriranno a breve!'
                              : !isCentroEstivoPage || registrationOpen
                                ? 'Diventa Socio'
                                : ''}
                        </Button>
                      )}
                    </Center>
                  )}
                </Box>
              </SimpleGrid>
            )}
          </Box>
        </Container>
      )}

      {/* Dettagli evento */}
      <Container maxW="container.xl" px={{ base: 2, md: 4 }} pb={10}>
        {!event?.Varianti?.length &&
        (isCentroEstivo || event?.checkoutMode === 'deck') ? (
          <Box
            p={{ base: 4, md: 6 }}
            mb={6}
            borderRadius="lg"
            boxShadow="md"
            position="relative"
            bg="white"
            color="gray.800"
          >
            {isCentroEstivo ? (
              <>
                {descrizioneBlock}
                {teamBlock}
              </>
            ) : null}

            {/* Contenuto condizionale per deck */}
            {event?.checkoutMode === 'deck' ? (
              <Box
                mb={6}
                p={6}
                bg="linear-gradient(135deg, #3182ce 0%, #2c5aa0 100%)"
                borderRadius="xl"
                boxShadow="xl"
                position="relative"
                overflow="hidden"
              >
                {/* Pattern decorativo */}
                <Box
                  position="absolute"
                  top="-50%"
                  right="-20%"
                  w="200px"
                  h="200px"
                  bg="whiteAlpha.100"
                  borderRadius="full"
                  opacity="0.3"
                />
                <Box
                  position="absolute"
                  bottom="-30%"
                  left="-10%"
                  w="150px"
                  h="150px"
                  bg="whiteAlpha.100"
                  borderRadius="full"
                  opacity="0.2"
                />

                <Box position="relative" zIndex={2}>
                  <Flex align="center" mb={6}>
                    <Icon
                      as={GiMagicTrident}
                      color="white"
                      fontSize="2xl"
                      mr={3}
                    />
                    <Heading as="h3" size="lg" color="white" fontWeight="bold">
                      Mazzi dei Partecipanti
                    </Heading>
                  </Flex>

                  {!canShowDecks() ? (
                    <Box textAlign="center" py={8}>
                      <Box
                        bg="whiteAlpha.200"
                        borderRadius="full"
                        w="80px"
                        h="80px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        mx="auto"
                        mb={4}
                      >
                        <Icon
                          as={GiMagicTrident}
                          color="white"
                          fontSize="3xl"
                        />
                      </Box>
                      <Text
                        fontSize="lg"
                        color="white"
                        mb={3}
                        fontWeight="semibold"
                      >
                        🔒 I mazzi saranno visibili a partire dall&apos;inizio
                        dell&apos;evento
                      </Text>
                      <Text
                        fontSize="md"
                        color="whiteAlpha.800"
                        maxW="400px"
                        mx="auto"
                      >
                        Per mantenere l&apos;elemento sorpresa, i mazzi dei
                        partecipanti verranno mostrati solo a partire
                        dall&apos;ora di inizio dell&apos;evento.
                      </Text>
                    </Box>
                  ) : loadingDecks ? (
                    <Center py={10}>
                      <Box textAlign="center">
                        <Spinner size="xl" color="white" thickness="4px" />
                        <Text
                          ml={4}
                          color="white"
                          fontSize="lg"
                          fontWeight="medium"
                        >
                          Caricamento mazzi...
                        </Text>
                      </Box>
                    </Center>
                  ) : participantDecks.length > 0 ? (
                    <Box>
                      <Flex align="center" justify="space-between" mb={6}>
                        <Badge
                          bg="whiteAlpha.200"
                          color="white"
                          fontSize="md"
                          px={4}
                          py={2}
                          borderRadius="full"
                          fontWeight="semibold"
                        >
                          {participantDecks.length} mazzo
                          {participantDecks.length !== 1 ? 'i' : ''} registrato
                          {participantDecks.length !== 1 ? 'i' : ''}
                        </Badge>
                        <Box
                          w="8px"
                          h="8px"
                          bg="green.300"
                          borderRadius="full"
                          boxShadow="0 0 10px rgba(72, 187, 120, 0.5)"
                        />
                      </Flex>

                      <Box
                        maxH="500px"
                        overflowY="auto"
                        css={{
                          '&::-webkit-scrollbar': {
                            width: '6px',
                          },
                          '&::-webkit-scrollbar-track': {
                            background: 'rgba(255,255,255,0.1)',
                            borderRadius: '3px',
                          },
                          '&::-webkit-scrollbar-thumb': {
                            background: 'rgba(255,255,255,0.3)',
                            borderRadius: '3px',
                          },
                          '&::-webkit-scrollbar-thumb:hover': {
                            background: 'rgba(255,255,255,0.5)',
                          },
                        }}
                      >
                        {participantDecks.map((deck, index) => (
                          <Box
                            key={deck.documentId || deck.id || index}
                            p={4}
                            mb={3}
                            bg="whiteAlpha.100"
                            backdropFilter="blur(10px)"
                            borderRadius="xl"
                            border="1px solid"
                            borderColor="whiteAlpha.200"
                            boxShadow="0 8px 32px rgba(0,0,0,0.1)"
                            transition="all 0.3s ease"
                            _hover={{
                              transform: 'translateY(-2px)',
                              boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                              bg: 'whiteAlpha.150',
                            }}
                          >
                            <Flex justify="space-between" align="center">
                              <Box flex="1">
                                <Flex align="center" mb={2}>
                                  <Box
                                    w="12px"
                                    h="12px"
                                    bg="green.300"
                                    borderRadius="full"
                                    mr={3}
                                    boxShadow="0 0 8px rgba(72, 187, 120, 0.6)"
                                  />
                                  <Text
                                    fontSize="lg"
                                    fontWeight="bold"
                                    color="white"
                                    textShadow="0 1px 2px rgba(0,0,0,0.3)"
                                  >
                                    {deck.nomeMazzo || 'Mazzo senza nome'}
                                  </Text>
                                </Flex>
                                {deck.user ? (
                                  <Text
                                    fontSize="sm"
                                    color="whiteAlpha.800"
                                    fontWeight="medium"
                                  >
                                    👤 {deck.user.firstName}{' '}
                                    {deck.user.lastName}
                                  </Text>
                                ) : null}
                              </Box>
                              <Button
                                as={Link}
                                to={`/decks/${deck.documentId || deck.id}`}
                                size="md"
                                bg="whiteAlpha.200"
                                color="white"
                                border="1px solid"
                                borderColor="whiteAlpha.300"
                                _hover={{
                                  bg: 'whiteAlpha.300',
                                  transform: 'scale(1.05)',
                                }}
                                _active={{
                                  transform: 'scale(0.95)',
                                }}
                                fontWeight="semibold"
                                px={6}
                                borderRadius="full"
                                transition="all 0.2s ease"
                              >
                                Vedi Deck
                              </Button>
                            </Flex>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  ) : (
                    <Box textAlign="center" py={8}>
                      <Box
                        bg="whiteAlpha.200"
                        borderRadius="full"
                        w="80px"
                        h="80px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        mx="auto"
                        mb={4}
                      >
                        <Icon
                          as={GiMagicTrident}
                          color="white"
                          fontSize="3xl"
                        />
                      </Box>
                      <Text fontSize="lg" color="white" fontWeight="medium">
                        Nessun mazzo registrato per questo evento
                      </Text>
                    </Box>
                  )}
                </Box>
              </Box>
            ) : null}
          </Box>
        ) : null}

        {isCentroEstivo ? (
          <CentroEstivo event={event} />
        ) : (
          <Box
            p={{ base: 5, md: 10 }}
            bg="white"
            borderRadius="lg"
            boxShadow="md"
            color="gray.800"
          >
            {descrizioneBlock}
            {variantiInDettagli && (
              <Box mb={8}>
                <Heading as="h2" size="md" mb={4} color="gray.800">
                  Date e turni
                </Heading>
                {variantiSection}
              </Box>
            )}
            {teamBlock}

            <EventProgrammaDettagli event={event} />
            <EventPricingSection event={event} />
          </Box>
        )}

        {event?.reward_sets?.length > 0 && (
          <EventRewardSetsSection rewardSets={event.reward_sets} />
        )}
      </Container>

      {/* DRAWER per pagamento/prenotazione */}
      {renderSocioDrawer()}
      {renderGuestDrawer()}
      {renderRapidDrawer()}

      {/* Notification Popup */}
      <NotificationPopup
        isOpen={showNotificationPopup}
        onClose={() => setShowNotificationPopup(false)}
        userData={userData}
      />
    </Box>
  );
}

// Wrapper invariato
const EventDetailWrapper = ({ userData, eventsData }) => {
  return <EventDetail userData={userData} eventsData={eventsData} />;
};

export default EventDetailWrapper;
